import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
    callAPI,
    compressImageFile,
    EPhone,
    formatPhoneNumber,
    Method,
    updateMainHeader,
} from "../../commonFunctions/CommonFunctions";
import http from "../../commonFunctions/httpClient";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSButton from "../../Components/Button/WSButton";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import {
    HeaderList,
    IHeaderListActions,
} from "../../Components/Header/HeaderList";
import WSRadioField from "../../Components/Radio/WSRadio";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { WSHeaderCard } from "../../Components/View/HeaderCard";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSTimePicker from "../../Components/WSTimePicker/WSTimePicker";
import clientConfig from "../../Config/clientConfig.json";
import config from "../../Config/config.json";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import WSAutocompleteField from "../../Components/AutoComplete/AutoComplete";
import WSMultiAutoComplete from "../../Components/AutoComplete/WSMultiAutocomplete";
import DateSchedule, { Schedule } from "./DateSchedule";
import { Dayjs } from "dayjs";
import DateScheduleCreate from "./DateScheduleCreate";
interface Shift {
    label: string;
    day?: string;
    fromTime?: string;
    toTime?: string;
    timeSlots: string[];
    selectedTimes: string[];
}
function getTimeSlots(from: string, to: string, hr: number): string[] {
    const result: string[] = [];
    let [fromHour, fromMinute] = from.split(":").map(Number);
    let [toHour, toMinute] = to.split(":").map(Number);

    while (fromHour < toHour || (fromHour === toHour && fromMinute < toMinute)) {
        const start = `${fromHour.toString().padStart(2, "0")}:${fromMinute
            .toString()
            .padStart(2, "0")}`;
        fromMinute += hr;
        if (fromMinute >= 60) {
            fromMinute = 0;
            fromHour += 1;
        }
        const end = `${fromHour.toString().padStart(2, "0")}:${fromMinute
            .toString()
            .padStart(2, "0")}`;
        result.push(`${start} - ${end}`);
    }

    return result;
}
interface ISlots {
    selected: Array<any>,
    unselected: Array<any>,
}
const DoctorCreate: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, reset } =
        useForm();
    const navigate = useNavigate();
    const params = useParams();
    const [imageUrl, setImageUrl] = useState<any>([]);
    const [userPermissions, setUserPermissions] = useState<any>([]);
    const [doctorData, setDoctorData] = useState<any>(null);
    const [permissions, setPermissions] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loaded, setloaded] = useState<boolean>(true);
    const [profileId, setProfileId] = React.useState<string | null>(null);
    const id = params?.id;
    const doctorUserId: any = params?.userId;
    const [slotsChanged, setSlotsChanged] = useState<ISlots>({ selected: [], unselected: [] });
    const [toTime, setToTime] = useState<string>();
    const [shifts, setShifts] = useState<Shift[]>([
        { label: "Shift 1", timeSlots: [], selectedTimes: [] },
    ]);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const { fields, append, remove, replace } = useFieldArray({
        name: "items",
        control,
    });

    useEffect(
        () => () => {
            reset();

        },
        []
    );
    const [specilisations, setSpecilisations] = useState<any>([])
    const [qualifications, setQualifications] = useState<any>([])
    const [services, setServices] = useState<any>([])
    useEffect(() => {
        append({
            startTime: "",
            endTime: "",
            day: "",
        });
    }, []);

    const appointMents: Array<any> = [
        { label: "Sunday", value: "Sunday" },
        { label: "Monday", value: "Monday" },
        { label: "Tuesday", value: "Tuesday2" },
        { label: "Wednesday", value: "Wednesday" },
        { label: "Thursday", value: "Thursday" },
        { label: "Friday", value: "Friday" },
        { label: "Saturday", value: "Saturday" },
    ];
    const consultationType: Array<any> = [
        { label: "In Clinic Visit", value: "In Clinic Visit" },
        // { label: 'Video Consultation', value: 'Video Consultation' },
        // { label: 'Patient Questions', value: 'Patient Questions', },
    ];

    const specilaisationsSource = {
        url: "Specialization/search",
        page: 1,
        pageSize: 1000000,
        filter: [],
        sort: [],
    };
    const qualificationSource = {
        url: "Qualifications/search",
        page: 1,
        pageSize: 1000000,
        filter: [],
        sort: [],
    };
    const serviceSource = {
        url: "DoctorService/search",
        page: 1,
        pageSize: 1000000,
        filter: [],
        sort: [],
    };

    useEffect(() => {
        updateMainHeader("Doctor");
    });

    breadCrumbsStore.updateBreadCrumbs([
        { "Doctor List": "/doctor/list" },
        { [!id ? "Add Doctor " : "Update Doctor "]: "/doctor/profile/add/:userId" },
    ]);

    useEffect(() => {
        /**
         * Method to get the user record by id for edit purpose
         * @param id
         */
        async function getDoctorById(id: any): Promise<void> {
            try {
                setloaded(false);

                const response: any = await http.get(`DoctorProfile/User/${id}`);
                if (response && response.data) {
                    // if (response.data.permissions) {
                    //     setUserPermissions(response.data.permissions)
                    // }
                    setProfileId(response.data?.id)
                    setDoctorData(response.data);
                    for (const field in response.data) {
                        if (field === "phoneNumber") {
                            setValue(
                                field,
                                formatPhoneNumber(
                                    (response?.data as any)[field],
                                    EPhone.AddHyphen
                                )
                            );
                        } else if (
                            field === "profileImageUrl" &&
                            response?.data[field] !== null
                        ) {
                            setImageUrl(
                                `${config.imgUrl}${response?.data[field].replace(
                                    "UploadedImages/",
                                    ""
                                )}`
                            );
                        } else {
                            setValue(field, (response?.data as any)[field]);
                        }
                    }


                    setSpecilisations(response?.data?.specializations?.map((s: any) => s.id) || []);
                    setQualifications(response?.data?.qualifications?.map((s: any) => s.id) || []);
                    setServices(response?.data?.doctorServices?.map((s: any) => s.id) || []);

                    // setValue(
                    //     "specializationId",
                    //     response.data?.specializations?.specializationId
                    // );

                }
                const scheduleResponse: any = await http.get(
                    `DoctorSchedule/Profile?doctorProfileId=${response.data?.id}`
                );
                if (scheduleResponse && scheduleResponse.data) {
                    // Transform the API data if needed before replacing
                    const scheduleItems = scheduleResponse.data.map((item: any) => ({
                        id: item.id, // required only if you're using keyField like 'id'
                        day: item.day,
                        startTime: item.startTime,
                        endTime: item.endTime,
                    }));

                    replace(scheduleItems); // this will populate the field array
                    setTimeout(() => {
                        setloaded(true);
                    }, 10);
                }
            } catch (error) {
                showMessage("Error fetching schedule:", "error");
            } finally {
                setTimeout(() => {
                    setloaded(true);
                }, 10);
            }
        }
        if (id) {
            getDoctorById(id);
        }
    }, [id]);

    const handleCancelClick = () => {
        navigate("/doctor/list");
    };
    const handleUploadChange = async (uploadedFile: any) => {
        const file: any = uploadedFile[0];
        try {
            let newFile: any = await compressImageFile(uploadedFile);
            setSelectedFile(newFile);
        } catch (error) {
            showMessage("Error converting file to base64:", "error");
        }
    };

    /**
     * Method for Add/Update the data
     * @param data
     */
    const onSubmit = async (data: any) => {



        // setProfileId('123123')
        // return
        try {
            setLoading(true);
            const request: any = await setRequest(data);

            if (id && doctorData?.id) {
                const response: any = await callAPI(
                    `DoctorProfile/${doctorData?.id}`,
                    Method.PUTFORMDATA,
                    null,
                    null,
                    request
                );
                if (response) {
                    if (response.success === true) {
                        const profileId = doctorData?.id;
                        const timesData: any = [
                            {
                                doctorProfileId: profileId,
                                schedules: data?.items || [],
                            },
                        ];
                        const getExisting: any = await http.get(
                            `DoctorSchedule/Profile?doctorProfileId=${profileId}`
                        );
                        if (getExisting?.success == true) {
                            const deleteExisting: any = await http.del(
                                `DoctorSchedule/schedule/doctor/${profileId}`
                            );
                            if (deleteExisting) {
                                const scheduleResponse: any = await callAPI(
                                    "DoctorSchedule",
                                    Method.POST,
                                    timesData,
                                    null,
                                    null
                                );
                            }
                        } else {
                            const scheduleResponse: any = await callAPI(
                                "DoctorSchedule",
                                Method.POST,
                                timesData,
                                null,
                                null
                            );
                        }
                    }
                    showMessage(
                        response?.message,
                        response.success === true ? "success" : "error"
                    );
                    response.success === true && navigate("/doctor/list");
                }
                
            } else {
                const response: any = await callAPI(
                    "DoctorProfile",
                    Method.POSTFORMDATA,
                    null,
                    null,
                    request
                );
                if (response) {
                    // if (response.success === true) {
                    //     const profileId = response?.data?.profileId || response?.id;
                    //     const timesData: any = [
                    //         {
                    //             doctorProfileId: profileId,
                    //             schedules: data?.items || [],
                    //         },
                    //     ];
                    //     const scheduleResponse: any = await callAPI(
                    //         "DoctorSchedule",
                    //         Method.POST,
                    //         timesData,
                    //         null,
                    //         null
                    //     );
                    // }
                    showMessage(
                        response?.message,
                        response.success === true ? "success" : "error"
                    );
                    response.success === true && navigate("/doctor/list");
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        } finally {
            setLoading(false);
        }
    };

/**
 * Set the request data for Doctor Profile
 * @param {any} data The data to be set in the request
 * @returns {Promise<any>} The request data
 */
    const setRequest = async (data: any) => {
        try {
            let imageName = "";
            if (data.imageUrl && data.imageUrl[0]) {
                const file = data.imageUrl[0];
                imageName = file.name;
            }
            const formData = new FormData();
            if (selectedFile) {
                formData.append("ProfileImage", selectedFile!);
            }
            formData.append("UserId", doctorUserId || id);
            formData.append("Age", data.age);

            const serviceNames = data.drServiceId.map((item: any) => item.value);

            const specializationIds = data.specializationId.map((item: any) => item.value);
            const qualification = data.qualificationId.map((item: any) => item.value);
            specializationIds?.map((item: any) => {
                formData.append("SpecializationIds", item);
            })
            qualification?.map((item: any) => {
                formData.append("QualificationIds", item);
            })
            serviceNames?.map((item: any) => {
                formData.append("doctorServiceIds", item);
            })
            // formData.append("qualificationId", data.qualificationId);
            // formData.append("drServiceId", data.drServiceId);
            // formData.append("specializationId", data.specializationId);
            formData.append("Fees", data?.fees);
            formData.append("Availabilities", data.items || []);
            formData.append("Gender", data.gender);
            formData.append("AddressLine1", data.addressLine1);
            formData.append("AddressLine2", data?.addressLine2);
            formData.append("State", data.state);
            formData.append("City", data.city);
            formData.append("Pincode", data.pincode);
            formData.append("MedicalUID", data.medicalUID);
            formData.append("Experience", data?.experience);
            formData.append("About", data?.about);

            return formData;
        } catch (e: any) {
            showMessage(e.error);
        }
    };

    // const handleDayChange = (value: string, index: number) => {
    //     const updated = [...shifts];
    //     updated[index].day = value;
    //     setShifts(updated);
    // };


    const handleFromTimeChange = (value: string, index: number) => {
        // const updated = [...shifts];
        // updated[index].fromTime = value;
        // if (updated[index].toTime) {
        //     updated[index].timeSlots = getTimeSlots(value, updated[index].toTime!, splitHour);
        //     updated[index].selectedTimes = [];
        // }
        // setShifts(updated);
        setToTime(value);
    };

    // const handleToTimeChange = (value: string, index: number) => {
    //     const updated = [...shifts];
    //     updated[index].toTime = value;
    //     if (updated[index].fromTime) {
    //         updated[index].timeSlots = getTimeSlots(updated[index].fromTime!, value, splitHour);
    //         updated[index].selectedTimes = [];
    //     }
    //     setShifts(updated);
    // };

    // const handleTimeSlotToggle = (time: string, index: number) => {
    //     const updated = [...shifts];
    //     const selected = updated[index].selectedTimes;
    //     if (selected.includes(time)) {
    //         updated[index].selectedTimes = selected.filter((t) => t !== time);
    //     } else {
    //         updated[index].selectedTimes = [...selected, time];
    //     }
    //     setShifts(updated);
    // };

    // const addShift = () => {
    //     setShifts([
    //         ...shifts,
    //         { label: `Shift ${shifts.length + 1}`, timeSlots: [], selectedTimes: [] },
    //     ]);
    // };
    // const handleRemoveShift = (index: number) => {
    //     const updated = [...shifts];
    //     updated.splice(index, 1);
    //     setShifts(updated);
    // };

    // const handleRadioHrChange = (evt: any, index: number) => {
    //     setSplitHour(evt.target.value)
    //     const updated = [...shifts];
    //     if (updated[index].toTime) {
    //         updated[index].timeSlots = getTimeSlots(updated[index].fromTime!, updated[index].toTime!, Number(evt.target.value));
    //         updated[index].selectedTimes = [];
    //     }
    //     setShifts(updated);
    // }

    const transFormDataSpecialisation = (data: any) => {
        const specilazation: Array<any> = [];
        if (data) {
            data.map((item: any) => {
                specilazation.push({ label: item.specializations, value: item.id });
            });
        }
        return specilazation;
    };
    const transFormDataQualification = (data: any) => {
        const qualifications: Array<any> = [];
        if (data) {
            data.map((item: any) => {
                qualifications.push({ label: item.name, value: item.id });
            });
        }
        return qualifications;
    };
    const transFormDataService = (data: any) => {
        const services: Array<any> = [];
        if (data) {
            data.map((item: any) => {
                services.push({ label: item.serviceName, value: item.id });
            });
        }
        return services;
    };
    const handleScheduleChange = (data: any) => {
        setSlotsChanged((prev) => {
            const hasChanged =
                JSON.stringify(prev.selected) !== JSON.stringify(data.selectedSlots) ||
                JSON.stringify(prev.unselected) !== JSON.stringify(data.unselectedSlots);

            return hasChanged
                ? { selected: data.selectedSlots, unselected: data.unselectedSlots }
                : prev; // return same state to avoid re-render
        });
    };

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} >
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={6}>
                        <Paper
                            elevation={0}
                            style={{
                                paddingLeft: 20,
                                paddingRight: 20,
                                marginTop: 0,
                                paddingBottom: 25,
                                borderRadius: "8px",
                            }}
                        >
                            <Grid container spacing={2} mt={0}>
                                <Grid item sm={12} xs={12}>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                        Basic Information{" "}
                                    </Typography>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        control={control}
                                        id="medicalUID"
                                        name="medicalUID"
                                        rules={{ required: true }}
                                        label="Medical UID *"
                                    ></WSTextField>
                                </Grid>

                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        maxLength={2}
                                        control={control}
                                        type={TextType.AllowOnlyNumber}
                                        id="age"
                                        name="age"
                                        rules={{ required: false }}
                                        label="Age *"
                                    ></WSTextField>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        label="Fees"
                                        type={TextType.AllowOnlyNumber}
                                        rules={{ required: false }}
                                        control={control}
                                        id="fees"
                                        name="fees"
                                    ></WSTextField>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSRadioField
                                        defaultValue={"Male"}
                                        control={control}
                                        label="Gender"
                                        rules={{ required: false }}
                                        id="gender"
                                        name="gender"
                                        options={clientConfig.genderConfig.staticOptionData}
                                    ></WSRadioField>
                                </Grid>
                                <Grid item sm={12} xs={12}>
                                    <WSTextAreaField
                                        control={control}
                                        name="experience"
                                        id="experience"
                                        label="Experience"
                                        rows={2}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper
                            elevation={0}
                            style={{
                                paddingLeft: 20,
                                paddingRight: 20,
                                marginTop: 0,
                                paddingBottom: 25,
                                borderRadius: "8px",
                                minHeight: "100%",
                            }}
                        >
                            <Grid container spacing={2} mt={0}>
                                <Grid item xs={12}>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                        {" "}
                                        Address Information
                                    </Typography>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        control={control}
                                        id="addressLine1"
                                        name="addressLine1"
                                        rules={{ required: true }}
                                        label="Address Line1 *"
                                    ></WSTextField>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        control={control}
                                        id="addressLine2"
                                        name="addressLine2"
                                        rules={{ required: false }}
                                        label="Address Line2 "
                                    ></WSTextField>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        control={control}
                                        id="state"
                                        name="state"
                                        rules={{ required: true }}
                                        label="State *"
                                    ></WSTextField>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        control={control}
                                        id="city"
                                        name="city"
                                        rules={{ required: true }}
                                        label="City *"
                                    ></WSTextField>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <WSTextField
                                        control={control}
                                        id="pincode"
                                        name="pincode"
                                        rules={{ required: true }}
                                        label="Pincode *"
                                        maxLength={6}
                                    ></WSTextField>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper
                            elevation={0}
                            style={{
                                paddingLeft: 20,
                                paddingRight: 20,
                                marginTop: 0,
                                paddingBottom: 25,
                                borderRadius: "8px",
                                minHeight: "100%",
                            }}
                        >
                            <Grid container spacing={2} mt={0}>
                                <Grid item xs={12}>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                        {" "}
                                        Additional Information
                                    </Typography>
                                </Grid>
                                <Grid item sm={12} xs={12}>
                                    <WSMultiAutoComplete
                                        rules={{ required: false }}
                                        {...register("qualificationId")}
                                        // id="qualificationId"
                                        control={control}
                                        source={qualificationSource}
                                        transFormData={transFormDataQualification}
                                        label="Qualification"
                                        name="qualificationId"
                                        setValue={setValue}
                                        defaultValue={qualifications}
                                        multiple={true}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <WSMultiAutoComplete
                                        rules={{ required: true }}
                                        // id="specializationId"

                                        multiple={true}
                                        control={control}
                                        source={specilaisationsSource}
                                        transFormData={transFormDataSpecialisation}
                                        setValue={setValue}
                                        defaultValue={specilisations}
                                        label="Specialization"
                                        name="specializationId"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <WSMultiAutoComplete
                                        rules={{ required: true }}
                                        // id="drServiceId"
                                        control={control}
                                        source={serviceSource}
                                        transFormData={transFormDataService}
                                        label="Service"
                                        name="drServiceId"
                                        setValue={setValue}
                                        multiple={true}
                                        defaultValue={services}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper
                            elevation={0}
                            style={{
                                paddingLeft: 20,
                                paddingRight: 20,
                                marginTop: 0,
                                paddingBottom: 25,
                                borderRadius: "8px",
                                minHeight: "100%",
                            }}
                        >
                            <Grid container spacing={2} mt={0}>
                                <Grid item xs={12}>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                        {" "}
                                        About
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <WSTextAreaField
                                        label="About"
                                        id="about"
                                        setValue={setValue}
                                        control={control}
                                        rules={{ required: true }}
                                        name="about"
                                        rows={4}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            style={{
                                paddingLeft: 20,
                                paddingRight: 20,
                                marginTop: 0,
                                paddingBottom: 25,
                                borderRadius: "8px",
                                minHeight: "100%",
                            }}
                        >
                            <Grid container spacing={2} mt={0}>
                                <Grid item xs={12}>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                        {" "}
                                        Profile
                                    </Typography>
                                </Grid>
                                <Grid item sm={4} xs={12}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item>
                                            <WSImageUpload
                                                control={control}
                                                id="profileImage"
                                                name="profileImage"
                                                label="Profile Image"
                                                rules={{ required: false }}
                                                onChange={handleUploadChange}
                                                imgUrl={imageUrl}
                                            />
                                        </Grid>

                                        <Grid item sx={{ mt: 2 }}>
                                            <Typography sx={{ fontSize: "0.875rem", color: "gray" }}>
                                                {doctorData?.user?.name}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {doctorData && (
                                    <Grid item sm={8} xs={12}>
                                        <Grid item container spacing={1} alignItems="center">
                                            <Grid item>
                                                <WSIcons.PhoneIcon
                                                    sx={{ fontSize: "0.875rem", mt: 1 }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    sx={{ fontSize: "0.875rem", color: "gray" }}
                                                >
                                                    {doctorData?.user?.phoneNumber}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item container spacing={1} alignItems="center">
                                            <Grid item>
                                                <WSIcons.EmailIcon
                                                    sx={{ fontSize: "0.875rem", mt: 1 }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Typography
                                                    sx={{ fontSize: "0.875rem", color: "gray" }}
                                                >
                                                    {doctorData?.user?.email
                                                        ? doctorData?.user?.email
                                                        : "-"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>

                        </Paper>
                    </Grid>


                    { profileId && <Grid item sm={12}>
                        <Paper
                            elevation={0}
                            style={{
                                paddingLeft: 20,
                                paddingRight: 20,
                                marginTop: 0,
                                paddingBottom: 25,
                                borderRadius: "8px",
                                minHeight: "100%",
                            }}
                        >

                            { <Grid container spacing={2} mt={0}>
                                <Grid item xs={12}>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                        {" "}
                                        Update Schedule
                                    </Typography>
                                </Grid>
                                <Grid item sm={12}>
                                    {profileId && <DateSchedule profileId={profileId} onChange={handleScheduleChange} />}
                                </Grid>

                                {/* <Grid item xs={12}>
                                <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                    {" "}
                                    Create  Schedule
                                </Typography>
                            </Grid> */}
                                {/* <Grid item sm={12}>
                                <DateScheduleCreate doctorProfileId={profileId} />
                            </Grid> */}

                                {/* <DateSchedule onChange={handleScheduleSlotsChange} /> */}
                                {/* <Box p={2}>
                                    <Grid container spacing={2}>
                                        {loaded &&
                                            fields.map((row, index) => (
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    key={row.id}
                                                    alignItems="center"
                                                    mt={1}
                                                    ml={1}
                                                >
                                                    <Grid item xs={3}>
                                                        <WSSelectField
                                                            label="Select a Day"
                                                            rules={{ required: true }}
                                                            {...register(`items.${index}.day`)}
                                                            id={`selectDay-${index}`}
                                                            control={control}
                                                            options={appointMents}
                                                        // onChange={(event) => handleProductChange(index, event)}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={4}>
                                                        <WSTimePicker
                                                            control={control}
                                                            id={`items.${index}.startTime`}
                                                            label="From Time"
                                                            ampm={false}
                                                            name={`items.${index}.startTime`}
                                                            rules={{ required: true }}
                                                            onChange={(e) => handleFromTimeChange(e, index)}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={4}>
                                                        <WSTimePicker
                                                            control={control}
                                                            id={`items.${index}.endTime`}
                                                            label="End Time"
                                                            ampm={false}
                                                            name={`items.${index}.endTime`}
                                                            rules={{ required: true }}
                                                            onChange={(e) => handleFromTimeChange(e, index)}
                                                        />
                                                    </Grid>

                                                    <Grid item display="flex" justifyContent="center">
                                                        <WSIcons.DeleteIcon
                                                            onClick={() => remove(index)}
                                                            sx={{ color: "red", cursor: "pointer" }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            ))}

                                        <Grid item xs={12} sx={{ marginLeft: 1 }}>
                                            <WSButton
                                                id="addButton"
                                                label="+ Add"
                                                size="small"
                                                sx={{backgroundColor:'#098963!important', "&:hover": {
                                        backgroundColor: "#066e4f!important",
                                    },}}
                                                onClick={() =>
                                                    append({
                                                        startTime: "",
                                                        endTime: "",
                                                        day: "",
                                                    })
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Box> */}
                            </Grid>}
                        </Paper>
                    </Grid>}
                    <Grid
                        container
                        justifyContent="flex-end"
                        spacing={2} // 16 px gap (2 × theme.spacing unit)
                        sx={{ mt: 2 }}
                    >
                        <Grid item>
                            <WSButton
                                id="cancel"
                                type="button"
                                label="Cancel"
                                size="medium"
                                onClick={handleCancelClick}
                                variant="outlined"
                                color="primary"
                                sx={{
                                    borderRadius: 8,
                                    width: "8rem",
                                    border: "1px solid #098963",
                                    color: "#098963",
                                    backgroundColor: "#FFFFFF",
                                }}
                            />
                        </Grid>

                        <Grid item>
                            <WSButton
                                id="submit"
                                type="submit"
                                label="Save"
                                size="medium"
                                variant="outlined"
                                onClick={handleSubmit(onSubmit)}
                                color="primary"
                                loading={loading}
                                sx={{
                                    borderRadius: 8,
                                    width: "8rem",
                                    border: "1px solid #098963",
                                    color: "#FFFFFF",
                                    backgroundColor: "#098963",
                                    "&:hover": {
                                        backgroundColor: "#066e4f",
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </form>

            <>

            </>
        </>
    );
});

export default DoctorCreate;
